/**
 * App — top-level shell.
 *
 * Mounts the SVG filter defs once (so any descendant can reference them
 * via `filter="url(#qd-filter-...)"`), then hands off to the router.
 */

import { RouterProvider } from 'react-router-dom';
import { SvgFilterDefs } from './filters';
import { router } from './routes/router';

export function App() {
  return (
    <>
      <SvgFilterDefs />
      <RouterProvider router={router} />
    </>
  );
}
